import * as React from 'react';

const SvgIconGlobetrotter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={26} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M17.7 4.034a7 7 0 11-9.9 9.9 7 7 0 019.9-9.9z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.076 1.993c.539.785.732 1.757.534 2.688-1.075.644-1.29 2.151-1.075 1.936.215-.215 1.291.43 1.291.43.432 0 .647-.645.647-.645 1.076 0 .645 2.368.86 2.582.213.214.86-.215.861.432.005.37-.07.735-.217 1.073a1.587 1.587 0 01-.213 2.369c-.217.215-1.506-.216-1.723-.433-.217-.217-.215-.642-.432-.859-.217-.217-1.074-.214-1.074-.214-.859-.863-1.29 0-1.937.644-.646.644-1.505-.214-1.505-.214s-1.507-1.507-.648-2.8c.86-1.293 1.293-.862 1.293-.862.86 0 1.291-1.291 1.721-1.721 0 0-1.29-1.721-1.508-1.075-.217.646-.766.864-1.289.428-.736-.609.8-2.954.8-2.954M7.801 4.034L5.25 1.485"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M6.973 24.485a.5.5 0 01-.39-.812c.9-1.133 3.546-2.188 6.667-2.188s5.765 1.055 6.668 2.188a.5.5 0 01-.39.812H6.972z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7 13.934l3.051 3.051c0 5-7.5 4.5-7.5 4.5M19.468 15.7A9.5 9.5 0 016.033 2.267"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconGlobetrotter;
